<template>
    <div style="height: 100%">
        <div class="sa-flexbox" style="padding-bottom: 20px">
            <div class="sa-flexbox-header">
                <sa-filter-component @submit="onSubmit" @reset="onReset">
                    <b-form>
                        <b-row class="sa-form-btn-filter">
                            <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                <label class="sa-label-data">Cognome</label>
                                <input class="sa-page-search-component-input" v-model="filtro.cognome" placeholder="Inserisci cognome..." />
                            </b-col>
                            <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                <label class="sa-label-data">Nome</label>
                                <input class="sa-page-search-component-input" v-model="filtro.nome" placeholder="Inserisci nome..." />
                            </b-col>
                            <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                <label class="sa-label-data">Tipologia</label>
                                <select class="sa-page-search-component-input sa-riepilogo-select" v-model="filtro.tipologia">
                                    <option v-for="item in tipologiaOptions" :key="item.text" :value="item.value" value-field="value">
                                        {{ item.text }}
                                    </option>
                                </select>
                            </b-col>
                            <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                <label class="sa-label-data">Distretto</label>
                                <input class="sa-page-search-component-input" v-model="filtro.distretto" placeholder="Inserisci distretto..." />
                            </b-col>
                        </b-row>
                    </b-form>
                </sa-filter-component>
            </div>
            <div class="sa-flexbox-body">
                <div class="b-table-sticky-header">
                    <span class="sa-flexbox-body-title">Riepilogo Protocolli</span>
                    <b-table sticky-header ref="table" stacked="lg" striped hover :items="items" :fields="fields" :current-page="currentPage" :per-page="perPage" :key="listKey" sort-icon-left head-variant="light" class="sa-b-table">
                        <template v-slot:cell(paziente)="{ item }">
                            <b>{{ item.cognome }} {{ item.nome }}</b>
                        </template>
                        <template #cell(protocollo)="{ item }">
                            <div>{{ item.numeroProtocollo }}</div>
                            <div class="sa-riepilogo-secondary">{{ formatDate(item.dataProtocollo) }}</div>
                        </template>
                        <template #cell(trattamento)="{ item }">
                            <div class="sa-riepilogo-nowrap">{{ formatDate(item.dataInizioTrattamento) }} - {{ formatDate(item.dataFineTrattamento) }}</div>
                            <div class="sa-riepilogo-secondary">{{ item.numeroGiorniTrattamento }} gg</div>
                        </template>
                        <template #cell(tipologiaTrasmissione)="{ item }">
                            <div>{{ item.tipologia }}</div>
                            <div class="sa-riepilogo-secondary">{{ formatDate(item.dataTrasmissione) }}</div>
                        </template>
                    </b-table>
                </div>
            </div>
            <div class="sa-list-component-footer">
                <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                    <b-col lg="3">
                        <p>Record Totali: {{ rows }}</p>
                    </b-col>
                    <b-col lg="9">
                        <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" size="sm"></b-pagination>
                    </b-col>
                </b-row>
            </div>
        </div>
        <modal-error ref="cmpModalError"></modal-error>
    </div>
</template>
<script>
import UtilityMixin from "../../../utility/UtilityMixin";
import ModalError from "../../../../template/components/modal/components/ModalError.vue";
import SaFilterComponent from "../../../../template/layout/components/SaFilterComponent.vue";
import axios from "axios";

export default {
    name: "RsaAdiProtocolliRiepilogoComponent",
    inject: ["openShowModalLoading", "closeShowModalLoading"],
    mixins: [UtilityMixin],
    components: { ModalError, SaFilterComponent },
    data() {
        return {
            rows: 0,
            perPage: 50,
            currentPage: 1,
            pathResource: "/rsaadiprotocollo",
            listKey: 0,
            items: [],
            filtro: { cognome: null, nome: null, tipologia: null, distretto: null },
            fields: [
                { key: "paziente", label: "Paziente", thStyle: { width: "16%" } },
                { key: "distretto", label: "Distretto", thStyle: { width: "12%" } },
                { key: "protocollo", label: "N. Protocollo / Data Protocollo", thStyle: { width: "18%" } },
                { key: "livello", label: "Livello", thStyle: { width: "10%" } },
                { key: "trattamento", label: "Inizio - Fine Trattamento / Giorni", thStyle: { width: "26%" } },
                { key: "tipologiaTrasmissione", label: "Tipologia / Data Trasmissione", thStyle: { width: "18%" } },
            ],
            tipologiaOptions: [
                { value: null, text: "- Seleziona Valore -" },
                { value: "ATTIVAZIONE", text: "Attivazione" },
                { value: "PROROGA", text: "Proroga" },
                { value: "VARIAZIONE", text: "Variazione" },
                { value: "CONCLUSIONE", text: "Conclusione" },
            ],
        };
    },
    mounted() {},
    watch: {
        currentPage() {
            let me = this;
            me.loadData();
        },
    },
    methods: {
        loadData() {
            let me = this;
            me.openShowModalLoading();
            let params = Object.assign({ page: me.currentPage, forPage: me.perPage }, me.filtro);
            UtilityMixin.methods.loadDataResources(me.pathResource + "/riepilogo", params, me.loadDataSuccess, me.loadDataError);
        },
        loadDataSuccess(response) {
            let me = this;
            me.items = response.data.data.list;
            me.rows = response.data.data.recordsNumber;
            me.listKey++;
            this.closeShowModalLoading();
        },
        loadDataError(error) {
            let me = this;
            this.closeShowModalLoading();
            me.$refs.cmpModalError.show(error.response.data.messaggio);
        },
        calcolaGiorniTrattamento(dataInizio, dataFine) {
            if (!dataInizio || !dataFine) {
                return "-";
            }
            let inizio = new Date(dataInizio);
            let fine = new Date(dataFine);
            let diffMs = fine - inizio;
            if (isNaN(diffMs) || diffMs < 0) {
                return "-";
            }
            return Math.round(diffMs / (1000 * 60 * 60 * 24)) + 1;
        },
        onSubmit() {
            let me = this;
            me.currentPage = 1;
            me.loadData();
        },
        onReset() {
            let me = this;
            me.filtro = { cognome: null, nome: null, tipologia: null, distretto: null };
            me.currentPage = 1;
            me.loadData();
        },
        scaricaCsv() {
            let me = this;
            me.openShowModalLoading();
            let link = process.env.VUE_APP_PATH_API + me.pathResource + "/riepilogo";
            let params = Object.assign({}, me.filtro, { page: 1, forPage: 100000 });
            axios
                .get(link, { params })
                .then((response) => {
                    console.log(response.data.data.list);
                    console.log(response.data.data.list);
                    me.closeShowModalLoading();
                    me.scaricaCsvRiepilogo(response.data.data.list);
                    me.showModalLoading = false;
                })
                .catch(() => {
                    me.showModalLoading = false;
                    me.closeShowModalLoading();
                });
        },
        scaricaCsvRiepilogo(list) {
            let me = this;

            console.log(list);

            // Colonne del report, nell'ordine in cui devono comparire nel CSV.
            // NOTA MAPPATURA: i campi del protocollo non hanno una corrispondenza 1:1
            // con le colonne del report accessi originale:
            //   DATA ACCESSO       <- dataProtocollo (solo data)
            //   ORA INIZIO          <- dataProtocollo (solo ora)
            //   ORA FINE            <- dataTrasmissione (solo ora), se assente = uguale a ORA INIZIO
            //   DURATA (MIN)        <- vuoto (non esiste una durata in minuti nel protocollo)
            //   OPERATORE           <- cognomeOperatore + nomeOperatore
            //   PROFESSIONE         <- profilo
            //   PAZIENTE            <- cognome + nome (identificativo)
            //   NOTA D'ACCESSO       <- distretto + denominazionePresidio
            //   NUMERO PRESTAZIONI  <- vuoto (nessun campo equivalente)
            //   ATTIVITA'            <- tipologia
            //   ESEGUITA             <- SI se dataTrasmissione è valorizzata, altrimenti NO
            //   NOTA                 <- livello
            let columnsProperty = [
                { key: "numeroProtocollo", label: "NUMERO PROTOCOLLO" },
                { key: "dataProtocollo", label: "DATA PROTOCOLLO" },
                { key: "dataInizioTrattamento", label: "DATA INIZIO TRATTAMENTO" },
                { key: "dataFineTrattamento", label: "DATA FINE TRATTAMENTO" },
                { key: "durata", label: "NUMERO GIORNI TRATTAMENTO" },

                // { key: "oraFine", label: "ORA FINE" },
                // { key: "durata", label: "DURATA (MIN)" },
                { key: "operatore", label: "OPERATORE" },
                { key: "professione", label: "PROFESSIONE" },
                { key: "paziente", label: "PAZIENTE" },
                { key: "distretto", label: "DISTRETTO" },
                //     { key: "numeroPrestazioni", label: "NUMERO PRESTAZIONI" },
                { key: "tipologia", label: "TIPOLOGIA" },
                { key: "dataTrasmissione", label: "DATA TRASMISSIONE" },
                { key: "livello", label: "LIVELLO" },
            ];

            // Normalizzo ogni protocollo nella forma delle colonne del report,
            // così la logica di generazione del CSV sotto resta identica a quella generica.
            let items = (list || []).map((item) => {
                return {
                    numeroProtocollo: item.numeroProtocollo,
                    dataProtocollo: me.formattaDataCsv(item.dataProtocollo),
                    dataInizioTrattamento: me.formattaDataCsv(item.dataInizioTrattamento),
                    dataFineTrattamento: me.formattaDataCsv(item.dataFineTrattamento),
                    durata: item.numeroGiorniTrattamento,
                    operatore: [item.cognomeOperatore, item.nomeOperatore].filter(Boolean).join(" "),
                    professione: item.profilo || "",
                    paziente: `${[item.cognome, item.nome].filter(Boolean).join(" ")}${item.identificativo ? " (" + item.identificativo + ")" : ""}`,
                    distretto: [item.distretto, item.denominazionePresidio].filter(Boolean).join(" - "),
                    //  numeroPrestazioni: "",
                    tipologia: item.tipologia || "",
                    dataTrasmissione: me.formattaDataCsv(item.dataTrasmissione),
                    livello: item.livello || "",
                };
            });

            var data = [];
            let csvHeaderFinal = [];
            let csvKeysFinal = [];
            let ketToInclude = {};

            if (items.length > 0) {
                for (let column of columnsProperty) {
                    if (!ketToInclude[column.key]) {
                        ketToInclude[column.key] = {
                            type: column.type ? column.type : "string",
                            label: column.label ? column.label : column.key.toUpperCase(),
                            visible: column.visible ?? true,
                        };
                    }
                }

                columnsProperty.forEach((column) => {
                    if (ketToInclude[column.key] && ketToInclude[column.key].visible) {
                        csvKeysFinal.push(column.key);
                        csvHeaderFinal.push(ketToInclude[column.key].label);
                    }
                });

                data.push(csvHeaderFinal);

                items.forEach((item) => {
                    let row = [];
                    csvKeysFinal.forEach((key) => {
                        let valore = item[key];
                        if (ketToInclude[key].type == "date") {
                            if (valore) {
                                valore = UtilityMixin.methods.formatDate(valore);
                            }
                        }
                        row.push(valore);
                    });
                    data.push(row);
                });
            }

            let dataString = "";
            var csvContent = "";
            data.forEach(function (infoArray, index) {
                dataString = infoArray.join(";");
                csvContent += index < data.length ? dataString + "\n" : dataString;
            });

            // The download function takes a CSV string, the filename and mimeType as parameters
            var download = function (content, fileName, mimeType) {
                var a = document.createElement("a");
                mimeType = mimeType || "application/octet-stream";

                if (navigator.msSaveBlob) {
                    // IE10
                    navigator.msSaveBlob(
                        new Blob([content], {
                            type: mimeType,
                        }),
                        fileName,
                    );
                } else if (URL && "download" in a) {
                    //html5 A[download]
                    a.href = URL.createObjectURL(
                        new Blob([content], {
                            type: mimeType,
                        }),
                    );
                    a.setAttribute("download", fileName);
                    document.body.appendChild(a);
                    a.click();
                    document.body.removeChild(a);
                } else {
                    location.href = "data:application/octet-stream," + encodeURIComponent(content); // only this mime type is supported
                }
            };

            download(csvContent, "riepilogo-protocolli.csv", "text/csv;encoding:utf-8");
        },
        formattaDataCsv(timestamp) {
            if (!timestamp) return "";
            let d = new Date(timestamp);
            return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()}`;
        },
        /*     formattaOraCsv(timestamp) {
            if (!timestamp) return "";
            let d = new Date(timestamp);
            return `${pad(d.getHours())}:${pad(d.getMinutes())}`;
        }, */
    },
};
function pad(n) {
    return n.toString().padStart(2, "0");
}
</script>

<style>
.sa-riepilogo-select {
    height: 34px;
    padding: 0.375rem 1.75rem 0.375rem 0.75rem;
    font-size: 0.9rem;
    line-height: 1.5;
    color: #495057;
    background-color: #fff;
    background-image: url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 5'%3E%3Cpath fill='%23343a40' d='M2 0L0 2h4zm0 5L0 3h4z'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: right 0.75rem center;
    background-size: 8px 10px;
    border: 1px solid #ced4da;
    border-radius: 0.25rem;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    cursor: pointer;
}
.sa-riepilogo-select:focus {
    border-color: #80bdff;
    outline: 0;
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}
.sa-riepilogo-secondary {
    display: block;
    font-size: 0.85rem;
    color: #6c757d;
    margin-top: 2px;
}
.sa-riepilogo-nowrap {
    white-space: nowrap;
}
</style>
